/* eslint-disable */
import store from '@/store/index'

const userId = store.state.common.sessionInfo.userId
const sessionStr = store.state.common.sessionInfo.sessionStr
const firmId = store.state.common.sessionInfo.firmId
const tel = store.state.common.sessionInfo.tel

let bankServe = '/abc-bank-channel'
if (window.g.BANK_ID === 39) {
  bankServe = '/xy-bank-channel'
} else if (window.g.BANK_ID === 35) {
  bankServe = '/base-bankchannel'
} else if (window.g.BANK_ID === 37) {
  bankServe = '/sn-bank-channel'
} else if (window.g.BANK_ID === 24) {
  bankServe = '/gz-cp-bank-channel'
}
export default {
  // 因为页面有跳转三方界面，不能直定义变量存储，统一放到sessionStorage中

  // huoqu图片验证码
  param_getCaptcha: {
    url: '/authn/authn/generateCaptcha',

    param: {}
  },
  // 校验圖片验证码
  param_validImgCaptcha: {
    url: '/authn/authn/validCaptcha',
    param: {
      capid: 'FE1973ECAC0D95A81E3197D8E177299E',
      capcode: 'SC6Y'
    }
  },

  // 登录
  param_login: {
    url: '/authn/authn/login',
    param: {
      captchaCode: '',
      password: '',
      terminalType: 4,
      type: 1,
      captchaId: ' ',
      capid: '',
      code: '11234',
      userType: 'T',
      marketId: '', // 市场id
      marketId: 3
    }
  },
  // 退出
  param_logout: {
    url: '/authn/authn/v1/logout',
    param: {
      terminalType: 4,
      sessionStr: sessionStr,
      userId: userId,
      userid: userId
    }
  },
  // 修改密码
  param_newUpdatePwdByOld: {
    url: '/authn/authn/v1/simpleFrontUpdatePwdInFlow',
    param: {
      loginAccount: null,
      oldPassword: null,
      password: null
    }
  },
  // 修改资金密码
  // 修改资金密码
  param_updateFundPwd: {
    // url: '/intraday-marketing-system/operate/updateFundPwd',
    url: '/intraday-marketing-system/operate/updateFundPwdGs',
    // url: '/intraday-marketing-system/operate/updateFundPwdEnd',
    param: {
      cellphone: null,
      oldPwd: null,
      newPassWord: null,
      bankId: null
    }
  },
  // 账号状态
  param_findUserStatusProcess: {
    url: '/base-desk-manage/queryAuthentication/v2/queryPlus',
    // url: '/intraday-trade-query-mongo/frontTradeController/findUserStatusProcess',
    param: {}
  },
  // 币种收入汇总(当天)
  param_currencyIncomeSumDay: {
    url: '/base-margin-front-queryservice/margin/currencyIncomeSumDay',
    param: {
    }
  },
  // 查询资金流水 --- 新
  param_queryFirmAccountFundsFlow: {
    url: '/base-margin-front-queryservice/margin/queryFirmAccountFundsFlow',
    param: {}
  },
  // 查询资金流水历史 --- 新
  param_queryFirmAccountFundsFlowH: {
    url: '/base-desk-statement/margin/findAccountFundsFlowHFront',
    param: {}
  },
  // 出入金 --- 新
  param_queryFirmBankAccountInoutFundsFlowFront: {
    url: '/base-margin-front-queryservice/margin/queryFirmBankAccountInoutFundsFlowFront',
    param: {}
  },
  // 查询资金状况（所有市场）
  param_findMyAsset: {
    url: '/base-margin-front-queryservice/margin/findMyAssetByFirmId',
    // url: '/base-margin-front-queryservice/margin/findMyAsset',
    param: {}
  },
  // f10查看商品资料
  param_findCommodityDetail: {
    // url: '/intraday-trade-query/commodity/findCommodityDetail',
    url: '/sec-trade-manage/evaluation/selectCommodityEvaluation',
    param: {}
  },
  // 查询资金划转
  param_queryFundsTransfer: {
    url: '/base-statement/margin/queryFundsTransfer',
    param: {}
  },
  // 持仓汇总
  param_queryUserPositionSummaries: {
    'url': '/intraday-trade-query/tradeQuery/queryHoldFront',
    'param': {
      'page': '1',
      'size': '20'
      // 'commodityId': '',
      // 'firmId': firmId
      // "sort": [{
      //     "direction": "DESC",
      //     "property": "createTime"
      // }]
    }
  },
  // 银行开户信息查询
  param_findTrader: {
    url: '/intraday-margin-query/bankCacheQuery/findTrader',
    param: {}
  },
  // 银行签约信息查询
  param_findBankInfo: {
    url: '/intraday-margin-query/bankCacheQuery/findBankInfo',
    param: {}
  },
  // 解约 //header中带marketId参数
  param_unSign: {
    url: '/intraday-bankchannel/signUnSign/unSign',
    param: {}
  },
  // 返回视频认证次数
  param_authnVideoQuantity: {
    url: '/base-desk-manage/baseVideoVerify/authnVideoQuantity',
    param: {}
  },
  // 手机号是否被使用
  param_phoneIsUsed: {
    // "url":"/bcnbasebizproxy/base/queryCode",
    url: '/bg-queryservicebak/tradequerybak/queryCode',
    param: {
      cellPhone: '手机号'
    }
  },
  // 查询当前用户是否注册
  param_getCellphoneExists: {
    url: '/base-desk-query/baseUserAudit/v1/getCellphoneExists',
    param: {}
  },
 
  // 新注册
  param_register: {
    url: '/intraday-marketing-system/frontUserMaintainController/registerUser',
    param: {
      captchaCode: '',
      captchaId: '',
      code: '',
      createWay: 2, // 开户通道 1 管理后台 2 网上开户
      marketId: 3,
      mobilePhone: '',
      lnviteCode: '',
      password: '',
      userName: '', // 用户名称
      userType: 1 // 用户类型 A:交易所管理用户 M:会员管理用户 T:交易员
    }
  },

  // 获取短信验证码 用于注册
  param_getCaptchabyMobiletoRegister: {
    url: '/authn/authn/sendCaptcha',
    param: {
      loginAccount: '',
      mark: 'SMS_179220765', // 根据短信模版固定
      id: '2'
    }
  },
  // 设置个人信息
  param_setUserInfo: {
    url: '/base-desk-manage/user/setUserInfo',
    param: {}
  },
  // 查询是否是主力合约
  param_findCommodityIsMain: {
    url: '/intraday-trade-query/commodity/findCommodityIsMain',
    param: {
      commodityIsMain: 0
    }
  },
  // Integer id;
  // Integer commodityId;
  // Integer commodityIsMain;//是否是主力合约 0：是 1：不是
  //   //获取短信验证码 用于注册
  //   param_getmessagesAuth: {
  //     "url":"/bcnbasebizproxy/base/getmessagesAuth",
  //     "param": {
  //       "cellPhone": "",
  //     }
  //   },
  // 获取短信验证码 用于注册
  param_getmessagesAuth: {
    url: '/authn/authn/sendCaptcha',
    param: {
      loginAccount: '',
      id: '2'
    }
  },

  // 忘记密码
  param_forgetPwd: {
    url: '/authn/authn/updateUserPassword',
    param: {
      loginAccount: '', //	用户名
      password: '',
      captchaCode: '', // 图形验证码
      captchaId: '', // 验证码序列号
      code: '' // 短信/邮箱验证码
    }
  },
  param_updatePwdByOld: {
    url: '/intraday-marketing-system/frontUserMaintainController/updatePwdByOld',
    param: {
      sessionStr: sessionStr,
      userId: userId,
      loginAccount: '',
      password: '',
      oldPassword: '',
      templateId: 31
    }
  },
  // 交易接口
  param_trades: {
    url: '/intraday-trade/trade/make', // 挂盘接口 新
    param: {
      bsFlag: null,
      commodityId: '',
      price: '',
      quantity: '',
      pickType: 'G'
    }
  },
  // 交易接口 摘牌接口 新
  param_make: {
    url: '/intraday-trade/trade/make', // 挂盘接口 新
    param: {
      bsFlag: null,
      commodityId: '',
      price: '',
      quantity: '',
      pickType: 'Z',
      rivalOrder: [
        // {
        //     rivalOrderId: '', // 摘单id
        //     quantity: '' // 数量
        // }
      ]
    }
  },
  // 交易接口 (市价)
  param_marketTake: {
    url: '/sec-trade/trade/marketTake',
    param: {
      bsFlag: null,
      commodityId: '',
      quantity: ''
    }
  },
  // 查询公告信息 获得某个栏目下的内容标题列表 get
  param_getArticle: {
    url: '/content/content/content',
    param: {
      page: '1',
      size: '20'
    }
  },
  // 资讯 -> 查询轮播图 // 2020:11:10
  param_carouselList: {
    // url: '/content/content/carouselList',
    url: '/content/content/carouselList',
    param: {
      page: '1',
      size: '20',
      sort: 'createTime,desc'
    }
  },
  // 资讯 -> 查询公告列表 // 2020:11:10
  param_noticeList: {
    // url: '/content/content/noticeList',
    url: '/content/content/noticeList',
    // url: '/content/content/v1/getCmsContentListDesc',
    param: {
      page: '1',
      size: '20',
      sort: 'createTime,desc'
    }
  },
  // 硒交查询公告
  param_noticeListByColumnId: {
    url: '/content/content/noticeListByColumnId',
    param: {}
  },
  // 查询栏目 get
  param_lowerColumn: {
    url: '/content/column/lowerColumn',
    param: {
    }
  },
  // 获得某栏目下的子栏目及子栏目的部分内容 get 20230427
  param_contentLowerAll: {
    url: '/content/content/contentLowerAll',
    param: {
      page: '1',
      size: '20'
      // sort: 'sequence,desc'
    }
  },
  // 获得某栏目下的子栏目及子栏目的部分内容 get
  param_lowerColumnAndTheirContent: {
    url: '/content/content/lowerColumnAndTheirContent',
    param: {
      page: '1',
      size: '20',
      columnId: '3',
      sort: 'sequence,desc'
    }
  },
  // 资讯 -> 获得详细内容
  param_getContentDetails: {
    // url: '/content/content/getContent',
    url: '/content/content/getContent',
    param: {
      id: null
    }
  },

  // 撤单
  withdrawLimitOrder: {
    url: '/intraday-trade/trade/cancel',
    data: {
      orderId: '' // 订单号
    }
  },
  // 全撤
  cancelAll: {
    'url': '/intraday-trade/trade/cancelAll',
    'data': {
      'commodityId': '', // 商品id
      'price': '', // 订立单价
      'quantity': '', // 订立数量
      'bsFlag': '' // 买卖方向
    }
  },
  // 撤买卖撤单
  cancelFlag: {
    'url': '/intraday-trade/trade/cancelFlag',
    'data': {
      'commodityId': '', // 商品id
      'price': '', // 订立单价
      'quantity': '', // 订立数量
      'bsFlag': '' // 买卖方向
    }
  },
  // 撤最后一笔
  cancelLastOrder: {
    url: '/sec-trade/trade/cancelLastOrder',
    data: {
      // commodityId: '' // 商品号
    }
  },
  // 多选撤单
  param_cancelFast: {
    url: '/sec-trade/trade/cancelFast',
    data: {
      orderList: '' // 订单号
    }
  },
  // 委托查询
  queryUserEntrusts: {
    url: '/intraday-trade-query/tradeQuery/queryOrderFront',
    data: {
      page: '0',
      size: '20',
      firmId: firmId,
      bsFlag: null,
      // "commodityId": "1",
      orderType: null,
      sort: [{
        direction: 'DESC',
        property: 'create_time'
      }]
    }
  },
  // 委托查询合计
  queryOrderFrontSum: {
    url: '/intraday-trade-query/tradeQuery/queryOrderFrontSum',
    data: {
      page: '0',
      size: '20',
      firmId: firmId,
      bsFlag: null,
      // "commodityId": "1",
      orderType: null,
      sort: [{
        direction: 'DESC',
        property: 'create_time'
      }]
    }
  },
  // 历史查询合计
  queryOrderFrontHSum: {
    url: '/intraday-trade-query/tradeQuery/queryOrderFrontHSum',
    data: {
      firmId: firmId,
      bsFlag: null,
      commodityId: null,
      // orderType: null,
      startTradeDay: null,
      endTradeDay: null
    }
  },
  // 历史成交合计
  queryTradeFrontHSum: {
    url: '/intraday-trade-query/tradeQuery/queryTradeFrontHSum',
    data: {
      firmId: firmId,
      bsFlag: null,
      commodityId: null,
      // orderType: null,
      startTradeDay: null,
      endTradeDay: null
    }
  },
  // 成交查询 排序字段无效
  queryUserClinches: {
    url: '/intraday-trade-query/tradeQuery/queryTradeList',
    data: {
      page: '0',
      size: '20',
      firmId: firmId,
      // "commodityId": "1",
      tradeType: null
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "createTime"
      // }]
    }
  },
  // 成交查询 合计
  queryTradeListSum: {
    url: '/intraday-trade-query/tradeQuery/queryTradeListSum',
    data: {
      page: '0',
      size: '20',
      firmId: firmId,
      // "commodityId": "1",
      tradeType: null
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "createTime"
      // }]
    }
  },
  // 持仓明细
  queryUserHoldingsSubsidiaries: {
    url: '/intraday-trade-query/tradeQuery/queryHoldDetailList',
    data: {
      page: '0',
      size: '20',
      firmId: firmId
      // "commodityId": "1",
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "openTime"
      // }]
    }
  },
  // 兑换记录
  queryUserExchange: {
    url: '/shop-desk/holdRecord/getExchange',
    data: {
      page: '0',
      size: '20',
      "sort": [{
        "direction": "DESC",
        "property": "createTime"
      }]
    }
  },
  // 锁仓记录
  queryUserLock: {
    url: '/shop-desk/holdRecord/getLock',
    data: {
      page: '0',
      size: '20',
      "sort": [{
        "direction": "DESC",
        "property": "createTime"
      }]
    }
  },
  // 提货记录
  queryUserPickListTea: {
    url: '/intraday-trade-query/delivery/getPickListTea',
    data: {
      page: '0',
      size: '20',
      firmId: firmId,
      marketId: 3
    }
  },
  // 当前持仓合计
  queryHoldDetailListSum: {
    url: '/intraday-trade-query/tradeQuery/queryHoldDetailListSum',
    data: {
      page: '0',
      size: '20',
      firmId: firmId
      // "commodityId": "1",
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "openTime"
      // }]
    }
  },
  // 持仓汇总
  queryUserPositionSummaries: {
    url: '/intraday-trade-query/tradeQuery/queryHoldFront',
    data: {
      page: '0',
      size: '20',
      firmId: firmId,
      // "commodityId": "1",
      bsFlag: null,
      holdNo: null
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "commodityId"
      // }]
    }
  },
  // 持仓汇总合计
  queryHoldFrontSum: {
    url: '/intraday-trade-query/tradeQuery/queryHoldFrontSum',
    data: {
      // 'page': '0',
      // 'size': '20',
      firmId: firmId
      // "commodityId": "1",
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "openTime"
      // }]
    }
  },
  // 客户待货
  queryMemberTotalHolds: {
    url: '/bg-cachebstservice/query/queryMemberTotalHolds',
    data: {
      page: '1',
      size: '20'
      // "commodityId": "1",
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "commodityName"
      // }]
    }
  },
  // 挂牌明细(挂牌资料)
  queryCommodityDetail: {
    url: '/bg-cachebstservice/query/queryCommodityDetail',
    data: {
      page: '1',
      size: '20',
      commodityId: ''
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "userId"
      // }]
    }
  },
  // 设置止盈止损
  setStopAndTakePrice: {
    url: '/bg-trade/setStopAndTakePrice',
    data: {
      holdDetailNo: '3a77ca36165943058bb49a57af753a9c', // 持仓明细号
      stopLossPrice: '', // 止损价 必传
      takeProfitPrice: '' // 止盈价 必传
    }
  },
  // 确认风险提示
  confirmRiskWarning: {
    url: '/intraday-marketing-system/frontTradeController/confirmRiskWarning',
    data: {}
  },
  // 确认风险提示(获取状态)
  param_confirmRiskWarningStatus: {
    url: '/intraday-marketing-system/frontTradeController/getConfirmRiskWarningStatus',
    param: {}
  },
  // 判断当前用户是否修改过资金密码
  param_getMoneyPwdFlgByFirmId: {
    url: '/intraday-marketing-system/operate/getMoneyPwdFlgByFirmId',
    data: {}
  },
  // 我的资产
  param_mineAsset: {
    url: '/intraday-trade-query/frontTradeController/mineAsset',
    param: {}
  },
  // 我的资产--转让盈亏
  param_mineAsset1: {
    url: '/intraday-marketing-system/frontTradeController/mineAsset1',
    param: {}
  },
  // 资产折合
  queryUserAccountMonies: {
    url: '/bg-cachebstservice/query/queryUserAccountMonies',
    data: {
      page: '1',
      size: '20'
      // "commodityId": "1",
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "firmId"
      // }]
    }
  },
  // 资金流水
  queryUserAccountMoneyios: {
    url: '/bg-cachebstservice/query/queryUserAccountMoneyios',
    data: {
      page: '1',
      size: '20',
      bizCode: '' // 101:转入;102：转出;传null或不传为查所有;传除101，102的值为查其它类型
      // "commodityId": "1",
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "id"
      // }]
    }
  },
  // 到期交收。临时接口
  param_getExpireTradeList: {
    url: '/intraday-trade-query/delivery/getExpireTradeList',
    data: {}
  },
  // 验收确认
  param_buyInspectionDeliveryConfirmt: {
    url: '/sec-delivery/manage/user/buyInspectionDeliveryConfirm',
    data: {}
  },
  // 收货确认
  param_buyCloseDeliveryConfirm: {
    url: '/sec-delivery/manage/user/buyCloseDeliveryConfirm',
    data: {}
  },
  // 交收查询
  queryDeliveryOrdersPc: {
    url: '/bg-cachebstservice/query/queryDeliveryOrdersPc',
    data: {
      page: '1',
      size: '20'
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "deliveryorderNo"
      // }]
    }
  },
  // 自营会员交收查询
  queryMemberDeliveryOrdersPc: {
    url: '/bg-cachebstservice/query/queryMemberDeliveryOrdersPc',
    data: {
      page: '1',
      size: '20'
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "deliveryorderNo"
      // }]
    }
  },
  // 挂牌接口End
  // 查询市场
  param_getQueryparamet: {
    url: '/bg-queryservice/tradequery/queryparamet',
    // "fid": "query",
    // "bid": "queryparamet",
    param: {
      userId: userId,
      sessionStr: sessionStr
    }
  },
  
  // 委托历史
  queryUserEntrustHS: {
    'url': '/intraday-trade-query/sqlite/findOrderListH',
    // 'url': '/intraday-trade-query/tradeQuery/queryOrderFrontH',
    data: {
      page: '0',
      size: '20',
      bsFlag: null,
      // "commodityId": "1",
      orderType: null,
      sort: [{
        direction: 'DESC',
        property: 'createTime'
      }]
    }
  },
  // 成交历史
  queryUserClinchHS: {
    // 'url': '/intraday-trade-query/tradeQuery/queryTradeFrontH',
    'url': '/intraday-trade-query/sqlite/findTradeListH',
    data: {
      page: '0',
      size: '20',
      // "commodityId": "1",
      tradeType: null,
      sort: [{
        direction: 'DESC',
        property: 'createTime'
      }]
    }
  },
  // 查询收获地址
  param_getUserAddress: {
    url: '/base-address/address/getUserAddress',
    param: {
      // addressId: null, // 收货地址表主键 false
      // defaultFlag: 0, // 是否设置为默认收获地址 (0:否 1:是) false
    }
  },
  // 删除收货地址
  param_deleteUserAddress: {
    url: '/base-address/address/deleteUserAddress',
    param: {
      addressId: null // 收货地址表主键
    }
  },
  // 编辑收获地址
  param_updateUserAddress: {
    url: '/base-address/address/updateUserAddress',
    param: {
      addressName: '', // 收货地址
      defaultFlag: 0, // 是否设置为默认收获地址 (0:否 1:是)
      postCode: '', // 邮政编码
      recipients: '', // 收货人
      recipientsCellphone: '', //	收货人电话
      region: '' // 地区(前端维护辅助字段)
    }
  },
  // 地址管理
  // 新增收货地址
  param_saveUserAddress: {
    // url: '/base-address/address/saveUserAddress',
    url: '/base-address/address/saveUserAddress',
    param: {
      addressName: '', // 收货地址
      defaultFlag: 0, // 是否设置为默认收获地址 (0:否 1:是)
      postCode: '', // 邮政编码
      recipients: '', // 收货人
      recipientsCellphone: '', //	收货人电话
      region: '' // 地区(前端维护辅助字段)
    }
  },
  // vip订单列表
  param_viplist: {
    url: '/fwpt/bbstqd/listorder',
    param: {
      sessionStr: sessionStr,
      userId: userId
    }
  },
  // vip状态
  param_vipstate: {
    url: '/fwpt/bbstqd/findUserisvip',
    param: {
      sessionStr: sessionStr,
      userId: userId
    }
  },
  // 修改资金密码
  param_updateMoneyPassword: {
    // url: '/intraday-marketing-system/operate/updateFundPwd',
    param: {
      // 'moneytoken': '',
      // 'newmoneytoken': ''
      oldPwd: '',
      newPassWord: '',
      bankId: ''
    }
  },
  // 资金服务 trademargin/checkPwd
  param_checkPwd: {
    url: '/bcnmarginservice/trademargin/checkPwd',
    param: {
      sessionStr: sessionStr,
      userId: userId,
      moneytoken: ''
    }
  },
  // 市价交易接口
  param_addMarketOrder: {
    url: '/bcntradeservice/trade/addMarketOrder',
    param: {
      firmId: firmId,
      commodityId: '',
      price: '',
      quantity: '',
      bsFlag: null,
      orderType: 'M',
      sessionStr: sessionStr,
      userId: userId
    }
  },
  /**现货买进 */
  // 新增个人开户审核(认证)
  param_savePersonAccountAudit: {
    url: '/intraday-marketing-system/frontAuditController/savePersonAccountAudit',
    param: {
      certNo: '', //证据号码
      certType: '1', //证据类型 1:身份证
      contactAddress: '', //联系地址
      idCartFrontImg: '', //身份证正面照片
      idCartNegativeImg: '', //身份证反面照片
      realName: '', //真实姓名
      urgencyContact: '', //	紧急联系人
      urgencyContactPhone: '' //紧急联系人手机号
    }
  },
  // 新增企业开户审核(认证)
  param_saveEnterpriseAccountAudit: {
    url: '/intraday-marketing-system/frontAuditController/saveEnterpriseAccountAudit',
    param: {
      companyCertCode: '', //公司证件代码
      companyCertImage: '', //公司证件照片
      companyCertType: '', //公司证件类型 1:营业执照号 2:组织机构代码 3:社会统一代码
      contactAddress: '', //联系地址
      idCartFrontImg: '', //身份证正面照片
      idCartNegativeImg: '', //身份证反面照片
      legalPersonCertNo: '', //法人证件号码
      legalPersonCertType: 1, //法人证据类型 1:身份证
      urgencyContact: '', //	紧急联系人
      urgencyContactPhone: '' //紧急联系人手机号
    }
  },
  // 查询认证信息
  param_findCertificationInfo: {
    url: '/intraday-marketing-system/frontAuditController/findCertificationInfo',
    param: {}
  },
  // 获取银行列表
  param_queryBank: {
    url: '/intraday-margin-query/marginQuery/findBank',
    param: {}
  },
  // 获取签约银行列表
  param_findSignBank: {
    url: '/intraday-margin-query/marginQuery/findSignBank',
    param: {}
  },
  // 签约
  param_userSign: {
    url: '/intraday-monibank/monibank/userSign',
    param: {
      bankId: '',
      bankAccount: '', // 银行卡号
      bankAccountName: '', // 账户名称
      fundPwd: '', // 资金密码
      openBankName: '', // 开户行名称
      openBankNum: '' // 开户行行号
    }
  },
  // 解约
  param_userUnSign: {
    url: '/intraday-monibank/monibank/userUnSign',
    param: {
      firmId: firmId,
      bankAccount: '', // 银行卡号
      bankId: ''
    }
  },
  // 出金
  // 出金
  param_fundOutByMarket: {
    url: '/gz-cp-bank-channel/sign/fundOutByMarket',
    param: {
      firmId: Number(firmId)
    }
  },
  // 转让
  param_transfer: {
    url: '/sec-trade/trade/transfer',
    data: {
      holdDetailId: 0, //持仓明细id
      price: 0,
      quantity: 0
    }
  },
  // 汇总转让
  param_holdTransfer: {
    url: '/sec-trade/trade/holdTransfer',
    data: {
      holdId: 0, //持仓汇总id
      price: 0,
      quantity: 0
    }
  },
  // 现货买进转让
  param_tqTransfer: {
    url: '/sec-trade/trade/tqTransfer',
    data: {
      holdDetailId: 0, //持仓明细id
      price: 0,
      quantity: 0
    }
  },
  // 资金流水
  param_queryMyIntegralDetail: {
    url: '/intraday-margin-query/marginQuery/queryMyIntegralDetail',
    param: {
      typeCode: null, //101出金 102入金 null 其它
      marketId: 3,
      page: 0,
      size: 15,
      sort: [{
        direction: 'DESC',
        property: 'occurTime'
      }]
    }
  },
  param_queryMyIntegralDetailHis: {
    url: '/intraday-margin-query/marginQuery/queryMyIntegralDetailHis',
    param: {
      starTime: '', // 开始时间
      endTime: '', // 结束时间
      typeCode: null, //101出金 102入金 null 其它
      marketId: 3,
      page: 0,
      size: 15,
      sort: [{
        direction: 'DESC',
        property: 'occurTime'
      }]
    }
  },
  // 商品策略查询
  param_queryCommodityStrategy: {
    url: '/intraday-trade-query/strategy/queryCommodityStrategy',
    param: {}
  },
  // 当前交收
  param_getDeliveryList: {
    url: '/intraday-trade-query/delivery/getDeliveryList',
    data: {
      page: 0,
      size: 10
      // "sort": [
      //   {
      //     "direction": "",
      //     "property": ""
      //   }
      // ],
      // "endTime": 0,
      // "startTime": 0
    }
  },
  // 历史交收
  param_getDeliveryListH: {
    url: '/intraday-trade-query/delivery/getDeliveryHList',
    data: {
      page: 0,
      size: 10
      // "sort": [
      //   {
      //     "direction": "",
      //     "property": ""
      //   }
      // ],
      // "endTime": 0,
      // "startTime": 0
    }
  },
  // 2020.10.26 现货买进交收撤销
  param_auditFirmDelivery: {
    url: '/sec-delivery/manage/user/auditFirmDelivery',
    data: {
      deliveryId: null
    }
  },
  // 历史交收
  param_getDeliveryHList: {
    url: '/intraday-trade-query/delivery/getDeliveryHList',
    data: {
      page: 0,
      size: 10
      // "sort": [
      //   {
      //     "direction": "",
      //     "property": ""
      //   }
      // ],
      // "endTime": 0,
      // "startTime": 0
    }
  },
  // 提货记录
  param_getPickList: {
    url: '/intraday-trade-query/delivery/getPickList',
    data: {
      page: 0,
      size: 10
      // "sort": [
      //   {
      //     "direction": "",
      //     "property": ""
      //   }
      // ],
      // "endTime": 0,
      // "startTime": 0
    }
  },
  // 仓单记录
  param_getWarehouseList: {
    url: '/intraday-trade-query/delivery/getWarehouseList',
    data: {
      page: 0,
      size: 10
      // "sort": [
      //   {
      //     "direction": "",
      //     "property": ""
      //   }
      // ],
      // "endTime": 0,
      // "startTime": 0
    }
  },
  // 2022 3 24 挂牌商品前台查询
  param_findCanPickByUserId: {
    url: '/intraday-trade-query/commodity/findCanPickByUserId',
    data: {
      commodityId: null
    }
  },
  // 提货申请
  param_addPick: {
    url: '/base-admin-manage/delivery/addDelivery',
    data: {
      deliveryQuantity: 0, //提货数量
      isCheck: 1,
      consigneeName: '', //联系人
      consigneePhone: '', //联系方式
      warehousId: 0 //仓单id
    }
  },
  //现货买进明细交收（前台）
  param_addDeliveryDetail: {
    url: '/sec-delivery/manage/user/addDeliveryDetail',
    data: {
      // "deliveryPrice": 0,//交收价格
      deliveryQuantity: 0, //交收数量
      holdDetailId: 0, //持仓明细（按汇总交收传null）
      holdId: null
    }
  },
  // 范围撤单
  param_rangeCancel: {
    url: '/sec-trade/trade/rangeCancel',
    param: {
      commodityId: 0,
      highPrice: 0,
      lowPrice: 0
    }
  },
  // 快捷转让(平仓)
  param_fastClose: {
    // url: '/sec-trade/trade/fastClose',
    url: '/intraday-trade/trade/make',
    param: {
      'commodityId': '', // 商品id
      'price': '', // 订立单价
      'quantity': '', // 订立数量
      'bsFlag': '' // 买卖方向
    }
  },
  // 快捷转让
  param_fastCloseN: {
    // url: '/sec-trade/trade/fastClose',
    url: '/sec-trade/refactTrade/fastClose', // 新摘单
    param: {
      bsFlag: null,
      commodityId: 0,
      price: 0,
      quantity: 0,
      pickType: 'Z',
      rivalOrder: [
        // {
        //     "quantity": 0,
        //     "rivalOrderId": 0 
        // }
      ]
    }
  },
  // 快捷现货买进转让(平仓)
  param_fastCloseTq: {
    url: '/sec-trade/trade/fastCloseTq',
    param: {
      bsFlag: null,
      commodityId: 0,
      price: 0,
      quantity: 0
    }
  },
  // 市场状态和公告id查询
  param_queryContentSystem: {
    url: '/intraday-trade-query/query/queryContentSystem',
    param: {}
  },
  // 商品现货买进费用策略查询
  param_queryCommodityTqTip: {
    url: '/intraday-trade-query/strategy/queryCommodityTqTip',
    param: {
      commodityId: null
    }
  },
  // 查询总盈亏 用户成交id盈亏查询
  param_queryTradeClosepl: {
    url: '/intraday-trade-query/query/queryTradeClosepl',
    param: {}
  },
  // 查询订立参数
  param_findConcludeStage: {
    url: '/intraday-trade-query/query/findConcludeStageData',
    param: {
      commodityId: null
    }
  },
  // 商品涨停跌停价查询
  findCommodityHighLow: {
    url: '/intraday-trade-query/query/findCommodityHighLow',
    data: {
      commodityId: 0
    }
  },
  // 当日资金流水查询
  queryFirmAccountFundsFlow: {
    url: '/base-margin-front-queryservice/margin/queryFirmAccountFundsFlow',
    data: {
      // page: 1,
      // size: 10,
      // endTime: null,
      // starTime: null
    }
  },
  // 历史资金流水查询
  queryFirmAccountFundsFlowH: {
    url: '/base-desk-statement/margin/findAccountFundsFlowHFront',
    data: {
      // page: 1,
      // size: 10,
      // endTime: null,
      // starTime: null
    }
  },
  // 交易商信息查询(恒丰开户)
  param_findUserIdTrader: {
    url: '/intraday-bankchannel/qilubank/findUserIdTrader',
    param: {}
  },
  // 交易商信息上报(恒丰开户)
  param_hengfengAddTrader: {
    url: '/intraday-bankchannel/qilubank/hengfengAddTrader',
    param: {
      //accountType 账户类型 1.投资者 2.特许服务商 3.总特许服务商 4.结算会员 5.渠道服务商 6.仓库管理员 7.综合会员 8.投资者（多种交易模式） 9.交易商 10.中立商 11.活动户 12.募集户
      accountType: '1', //投资者
      amount: '',
      arcredentialsCode: '', // 法人证件号
      arcredentialsType: '1', // 法人证件类型 1-身份证
      artificialContact: '', // 法人联系方式
      artificialPerson: '', // 法人名称
      bankAccountID: '', // 银行账号
      bankAccountMobile: '',
      bankId: 0, // 银行ID
      corprateCertExpiry: '',
      corprateCertExpiryEnd: '',
      credentialsCode: '', //证件号
      //credentialsType 证件类型 1-身份证 2-军人军官证 3-港澳台居民通行证 4-中国护照 5-单位统一代码 6-未登记证件 7-暂住证 8-武警警官证 9-临时身份证 10-联名户 11-户口簿 12-中国居民其他证 13-军人士兵证 14-军人文职干部证 15-军人其他证件 16-武警士兵证 17-武警文职干部证 18-武警其他证件 19-外国护照 20-外国公民其他证件 21-重复有效证件 22-解放军士兵证 23-解放军文职干部证 24-解放军其它个人证件 25-武警士兵证 26-武警文职干部证 27-武警其它个人证件 51-法人代码证 52-组织机构代码证 53-政府机构/公共机构批文 54-外交部 外事办批文（使） 55-外交部 外事办批文（领） 56-外交部 外事办批文（办） 60-香港商业登记证 65-事业单位登记证 66-社会团体登记证 67-商业登记证（离岸） 68-营业执照 69-对公临时证件 70-其他证明文件(公司) 71-公司户重复有效证件 73-统一社会信用代码 80-金融机构
      credentialsType: '', //证件类型
      mobile: '', //	手机号
      //openBankId 开户银行编码 00  民生银行         56  鄂尔多斯银行              B6  四川天府银行		H2   山东荣成农村商业银行 01  工商银行         57  阜新银行                  B7  宁夏银行			H3   内蒙古自治区农村信用社联合社02  中国银行         58  福建海峡银行              B9  平顶山银行			H4   云南省农村信用社联合社03  建设银行         59  富滇银行                  C0  攀枝花市商业银行    04  农业银行         61  富邦华一银行              C1  泉州银行            05  交通银行         62  赣州银行                  C2  齐鲁银行            06  招商银行         63  广州银行                  C3  青岛银行            07  兴业银行         64  广东华兴银行              C4  齐商银行            08  中信银行         65  广东南粤银行              C5  曲靖市商业银行      09  光大银行         66  广西北部湾银行            C6  青海银行            10  平安银行         67  桂林银行                  C7  企业银行            11  华夏银行         68  贵阳银行                  C8  日照银行            12  邮政储蓄银行     69  广州农村商业银行          C9  盛京银行            13  北京银行         72  河北银行                  D0  绍兴银行            14  广发银行         73  邯郸银行                  D1  厦门银行            15  浦东发展银行     74  衡水银行                  D2  上饶银行            16  浙商银行         75  葫芦岛银行                D3  顺德农村商业银行    17  徽商银行         77  湖州银行                  D5  深圳前海微众银行    19  江苏银行         78  汉口银行                  D7  深圳农村商业银行    20  上海银行         79  湖北银行                  E0  厦门国际银行        21  南京银行         80  华融湘江银行              E1  天津银行            22  杭州银行         81  海口联合农村商业银行      E2  泰安银行            23  苏州银行         82  恒丰银行                  E3  太仓农村商业银行    24  宁波银行         84  黄河农村商业银行          E4  天津农村商业银行    25  温州银行         85  韩亚银行                  E5  乌海银行            26  台州银行         87  晋商银行                  E7  潍坊银行            27  包商银行         88  晋城银行                  E8  威海市商业银行      28  哈尔滨银行       89  晋中银行                  E9  乌鲁木齐银行        29  渤海银行         90  锦州银行                  F0  无锡农村商业银行    30  东亚银行         91  吉林银行                  F1  吴江农村商业银行    31  上海农村商业银行 92  江苏长江商行              F2  武汉农村商业银行    3  鞍山市商业银行   93  嘉兴银行                  F3  邢台银行            33  北京农村商业银行 94  金华银行                  F4  西安银行            36  承德银行         95  九江银行                  F5  新韩银行            37  沧州银行         96  济宁银行                  F6  营口银行            38  长沙银行         97  焦作市商业银行            F7  烟台银行            39  成都银行         98  江阴农商银行              F8  玉溪市商业银行      40  重庆银行         A3  昆仑银行                  F9  宁波鄞州农村商业银行41  长安银行         A4  昆山农村商业银行          G1  友利银行            42  常熟农村商业银行 A5  廊坊银行                  G2  张家口银行          43  成都农村商业银行 A6  龙江银行                  G3  浙江稠州商业银行    44  重庆农村商业银行 A7  莱商银行                  G4  浙江泰隆商业银行    47  重庆三峡银行     A8  临商银行                  G5  浙江民泰商业银行    48  大连银行         A9  洛阳银行                  G6  枣庄银行            49  东营银行         B0  柳州银行                  G7  郑州银行            50  德州银行         B1  兰州银行                  G8  中原银行            51  东莞银行         B2  绵阳市商业银行            G9  珠海华润银行        52  德阳银行         B3  内蒙古银行                H0  自贡银行            54  东莞农村商业银行 B4  宁波通商银行              H1  张家港农村商业银行
      openBankId: '', //开户银行编码
      registCapital: '', //注册资本
      status: '1', //交易商状态 0：注销，1：交易商正常，2：交易商冻结
      traderID: firmId, //交易商代码
      traderName: '', //交易商名称
      type: '' //交易商类型 01：自然人，02：机构
    }
  },
  // 恒丰银行销户（销户）
  param_traderCancellation: {
    url: '/intraday-bankchannel/qilubank/traderCancellation',
    param: {}
  },
  // 查询开户&签约状态
  param_findUserSignStatus: {
    url: '/intraday-bankchannel/qiluBankQuery/findUserSignStatus',
    param: {}
  },
  // 查询签约状态
  param_HFfindUserSign: {
    url: '/intraday-bankchannel/qiluBankQuery/findUserSign',
    param: {}
  },
  // 恒丰银行绑卡（签约）
  param_tiedCard: {
    url: '/intraday-bankchannel/qilubank/tiedCard',
    param: {
      amount: '', //认证金额 【机构选填】
      bankAcc: '', //银行卡号【选填】
      bankNo: '', //开户银行编码【选填】
      mobile: '' //手机号【选填】
    }
  },
  // 恒丰银行解绑（解约）
  param_traderRelieve: {
    url: '/intraday-bankchannel/qilubank/traderRelieve',
    param: {
      type: 0
    }
  },
  // 换绑卡
  param_traderRelieve1: {
    url: '/intraday-bankchannel/qilubank/traderRelieve',
    param: {
      bankAcc: null, //  银行卡号
      bankNo: null, //  银行编码
      type: null, //  操作类型 0解约  1修改签约信息
      bindBankName: null, //   开户行名
      mobile: null // 新绑定预留手机号
    }
  },
  // 交易商信息上报(通用开户)
  param_addTrader: {
    url: '/intraday-bankchannel/qilubank/addTrader',
    param: {
      //accountType 账户类型 1.投资者 2.特许服务商 3.总特许服务商 4.结算会员 5.渠道服务商 6.仓库管理员 7.综合会员 8.投资者（多种交易模式） 9.交易商 10.中立商 11.活动户 12.募集户
      accountType: '1', //投资者
      arcredentialsCode: '', // 法人证件号
      arcredentialsType: '1', // 法人证件类型 1-身份证
      artificialContact: '', // 法人联系方式
      artificialPerson: '', // 法人名称
      bankAccountID: '', // 银行账号
      bankId: 0, // 银行ID
      credentialsCode: '', //证件号
      //credentialsType 证件类型 1-身份证 2-军人军官证 3-港澳台居民通行证 4-中国护照 5-单位统一代码 6-未登记证件 7-暂住证 8-武警警官证 9-临时身份证 10-联名户 11-户口簿 12-中国居民其他证 13-军人士兵证 14-军人文职干部证 15-军人其他证件 16-武警士兵证 17-武警文职干部证 18-武警其他证件 19-外国护照 20-外国公民其他证件 21-重复有效证件 22-解放军士兵证 23-解放军文职干部证 24-解放军其它个人证件 25-武警士兵证 26-武警文职干部证 27-武警其它个人证件 51-法人代码证 52-组织机构代码证 53-政府机构/公共机构批文 54-外交部 外事办批文（使） 55-外交部 外事办批文（领） 56-外交部 外事办批文（办） 60-香港商业登记证 65-事业单位登记证 66-社会团体登记证 67-商业登记证（离岸） 68-营业执照 69-对公临时证件 70-其他证明文件(公司) 71-公司户重复有效证件 73-统一社会信用代码 80-金融机构
      credentialsType: '', //证件类型
      mobile: '', //	手机号
      //openBankId 开户银行编码 00  民生银行         56  鄂尔多斯银行              B6  四川天府银行		H2   山东荣成农村商业银行 01  工商银行         57  阜新银行                  B7  宁夏银行			H3   内蒙古自治区农村信用社联合社02  中国银行         58  福建海峡银行              B9  平顶山银行			H4   云南省农村信用社联合社03  建设银行         59  富滇银行                  C0  攀枝花市商业银行    04  农业银行         61  富邦华一银行              C1  泉州银行            05  交通银行         62  赣州银行                  C2  齐鲁银行            06  招商银行         63  广州银行                  C3  青岛银行            07  兴业银行         64  广东华兴银行              C4  齐商银行            08  中信银行         65  广东南粤银行              C5  曲靖市商业银行      09  光大银行         66  广西北部湾银行            C6  青海银行            10  平安银行         67  桂林银行                  C7  企业银行            11  华夏银行         68  贵阳银行                  C8  日照银行            12  邮政储蓄银行     69  广州农村商业银行          C9  盛京银行            13  北京银行         72  河北银行                  D0  绍兴银行            14  广发银行         73  邯郸银行                  D1  厦门银行            15  浦东发展银行     74  衡水银行                  D2  上饶银行            16  浙商银行         75  葫芦岛银行                D3  顺德农村商业银行    17  徽商银行         77  湖州银行                  D5  深圳前海微众银行    19  江苏银行         78  汉口银行                  D7  深圳农村商业银行    20  上海银行         79  湖北银行                  E0  厦门国际银行        21  南京银行         80  华融湘江银行              E1  天津银行            22  杭州银行         81  海口联合农村商业银行      E2  泰安银行            23  苏州银行         82  恒丰银行                  E3  太仓农村商业银行    24  宁波银行         84  黄河农村商业银行          E4  天津农村商业银行    25  温州银行         85  韩亚银行                  E5  乌海银行            26  台州银行         87  晋商银行                  E7  潍坊银行            27  包商银行         88  晋城银行                  E8  威海市商业银行      28  哈尔滨银行       89  晋中银行                  E9  乌鲁木齐银行        29  渤海银行         90  锦州银行                  F0  无锡农村商业银行    30  东亚银行         91  吉林银行                  F1  吴江农村商业银行    31  上海农村商业银行 92  江苏长江商行              F2  武汉农村商业银行    3  鞍山市商业银行   93  嘉兴银行                  F3  邢台银行            33  北京农村商业银行 94  金华银行                  F4  西安银行            36  承德银行         95  九江银行                  F5  新韩银行            37  沧州银行         96  济宁银行                  F6  营口银行            38  长沙银行         97  焦作市商业银行            F7  烟台银行            39  成都银行         98  江阴农商银行              F8  玉溪市商业银行      40  重庆银行         A3  昆仑银行                  F9  宁波鄞州农村商业银行41  长安银行         A4  昆山农村商业银行          G1  友利银行            42  常熟农村商业银行 A5  廊坊银行                  G2  张家口银行          43  成都农村商业银行 A6  龙江银行                  G3  浙江稠州商业银行    44  重庆农村商业银行 A7  莱商银行                  G4  浙江泰隆商业银行    47  重庆三峡银行     A8  临商银行                  G5  浙江民泰商业银行    48  大连银行         A9  洛阳银行                  G6  枣庄银行            49  东营银行         B0  柳州银行                  G7  郑州银行            50  德州银行         B1  兰州银行                  G8  中原银行            51  东莞银行         B2  绵阳市商业银行            G9  珠海华润银行        52  德阳银行         B3  内蒙古银行                H0  自贡银行            54  东莞农村商业银行 B4  宁波通商银行              H1  张家港农村商业银行
      openBankId: '', //开户银行编码
      registCapital: '', //注册资本
      status: '1', //交易商状态 0：注销，1：交易商正常，2：交易商冻结
      traderID: firmId, //交易商代码
      traderName: '', //交易商名称
      type: '' //交易商类型 01：自然人，02：机构
    }
  },

  /*青岛清算所*/

  // 用户结算单查询
  param_queryStatements: {
    url: '/intraday-marketing-system/frontUserExport/queryStatements',
    param: {
      page: 0,
      size: 1
    },
    data: {
      page: 0,
      size: 1
    }
  },
  // 用户结算单下载
  param_statementsDownload: {
    url: '/intraday-marketing-system/frontUserExport/statementsDownload',
    param: {
      tradeDay: null
    }
  },
  // 资金划转市场列表
  param_findAccountByUserId: {
    url: '/intraday-marketing-system/operate/findAccountByUserId',
    param: {}
  },
  // 资金多市场划转
  param_transferFundsOwn: {
    'url': '/intraday-marketing-system/operate/transferFundsOwn',
    'param': {
      'amount': null
      // 20220224 fromUserAccountId、toUserAccountId取消两个字段
      // 'fromUserAccountId': null,
      // 'toUserAccountId': null
    }
  },
  // 获取站内信
  param_getWebsiteMessage: {
    url: '/stationmsg/internal/postMsgInternal',
    param: {
      sort: [{
        direction: 'DESC',
        property: 'createTime'
      }]
    }
  },
  // 查看对手方手机号
  param_getAnalogueMobile: {
    url: '/intraday-trade-query/tradeQuery/getOrderContractInfo',
    param: {
      bsFlag: '', // 买卖方向
      commodityId: 0, // 商品id
      price: 0, // 订立单价
      quantity: 0 // 订立数量
    }
  },
  // 发送短信
  param_sendMes: {
    url: '/base-margin-service/margin/sendSMS',
    param: {
      bankId: 21
    }
  },
  // 忘记登录密码
  param_forgetLoginPwd: {
    url: '/authn/authn/v1/frontForgetPwd',
    param: {
      checkWay: 1,
      templateId: 49
    }
  },
  // 查询是否签约
  param_findBankAccount: {
    // url: '/intraday-margin-query/bankCacheQuery/findBankAccount',
    url: '/intraday-margin-query/bankCacheQuery/findBankInfo',
    param: {}
  },
  // 查询是否签约
  param_findBankAccountTea: {
    // 'url': '/intraday-trade-query/accountSign/getAccountSign',
    'url': '/intraday-margin-query/bankCacheQuery/findBankInfo',
    'param': {}
  },
  // 登陆短信提示接口
  param_sendMsgLoginInformation: {
    url: 'authn/authn/sendMsgLoginInformation',
    param: {
      title: '',
      type: 1,
      templateId: 50,
      params: [new Date(), 'pc端']
    }
  },
  // 行情
  // 新增自选
  param_addCommodityFirmMark: {
    url: '/intraday-trade-query/commodityMark/addCommodityFirmMark',
    param: {
      commodityId: null // Integer
    }
  },
  // 删除自选
  param_deleteCommodityFirmMark: {
    url: '/intraday-trade-query/commodityMark/deleteCommodityFirmMark',
    param: {
      commodityId: null // Integer
    }
  },
  // 查询自选
  param_findSymbolMarkList: {
    url: '/intraday-trade-query/symbolMarkQuery/findSymbolMarkList',
    param: {}
  },
  // 查询优选商品 /intraday-trade-query
  param_findOptSymbolList: {
    url: '/intraday-trade-query/symbolMarkQuery/findOptSymbolList ',
    param: {}
  },
  // 设置止盈止损(持仓明细)
  param_addStopPrice: {
    url: '/sec-trade/trade/addStopPrice',
    param: {
      holdDetailId: 0,
      stopLossPrice: 0,
      stopProfitPrice: 0
    }
  },
  // 提货 -- 持仓汇总
  param_addDelivery: {
    url: '/intraday-delivery/manage/user/addDelivery',
    param: {
    }
  },
  // 兑换 -- 持仓汇总
  param_convertHold: {
    url: '/intraday-trade/trade/convertHold',
    param: {
    }
  },
  // 锁仓 -- 持仓明细
  param_lockHold: {
    url: '/intraday-trade/trade/lockHold',
    param: {
    }
  },
  // 撤销止盈止损 设置那个为0代表撤销止盈或止损
  param_setStopPrice: {
    url: '/sec-trade/trade/setStopPrice',
    param: {
      // "stopLossPrice": 0,
      // "stopProfitPrice": 0
    }
  },
  // 导出 当日委托
  param_tq_tradeQuery_exportOrderFront: {
    url: '/intraday-trade-query/tradeQuery/exportOrderFront',
    param: {

    }
  },
  // 导出 历史委托
  param_tq_tradeQuery_exportOrderFrontH: {
    url: '/intraday-trade-query/tradeQuery/exportOrderFrontH',
    param: {

    }
  },
  // 导出 当日成交
  param_tq_tradeQuery_exportTradeList: {
    url: '/intraday-trade-query/tradeQuery/exportTradeList',
    param: {

    }
  },
  // 导出 历史成交
  param_tq_tradeQuery_exportTradeFrontH: {
    url: '/intraday-trade-query/tradeQuery/exportTradeFrontH',
    param: {

    }
  },
  // 导出 持仓明细
  param_tq_tradeQuery_exportHoldDetailList: {
    url: '/intraday-trade-query/tradeQuery/exportHoldDetailList',
    param: {

    }
  },
  // 导出 持仓汇总
  param_tq_tradeQuery_exportHoldFront: {
    url: '/intraday-trade-query/tradeQuery/exportHoldFront',
    param: {

    }
  },
  // 交收订货
  param_tq_queryDeliveryStock: {
    url: '/intraday-trade-query/tradeQuery/queryDeliveryStock',
    data: {

    }
  },
  // 交收订货 导出
  param_tq_exportDeliveryStock: {
    url: '/intraday-trade-query/tradeQuery/exportDeliveryStock',
    param: {

    }
  },
  // 当前资金 导出
  param_tq_exportFirmAccountFundsFlow: {
    url: '/base-margin-front-queryservice/margin/exportFirmAccountFundsFlow',
    param: {

    }
  },
  // 历史资金 导出
  param_tq_exportFirmAccountFundsFlowH: {
    url: '/base-margin-front-queryservice/margin/exportFirmAccountFundsFlowH',
    param: {

    }
  },
  // 报表系统 订单报表 -资金状况
  param_findUserReportOrderMargin: {
    url: '/intraday-trade-query/query/findUserReportOrderMargin',
    data: {
      'startDate': null,
      'endDate': null

    }
  },
  // 资金状况 导出
  param_tq_exportUserReportOrderMargin: {
    url: '/intraday-trade-query/query/exportUserReportOrderMargin',
    param: {

    }
  },
  // --------青岛相关的签约解约出金接口
  // 出金
  param_marketOutFund_qd: {
    url: '/qd-common-marginservice/margin/marketOutFund',
    param: {

    }
  },

  // 2022/03/10 挂牌修改新增请求
  // 查询打款验证信息
  /**
   * 签约解约分开判断，后台确保逻辑正确
    未签约 0 、确认中 3、已签约 1 、已解约2 、签约失败 4 、解约失败 5  待打款验证 13 、打款验证失败 6
    上方展示状态逻辑
    先查签约信息  看sign_flag是不是2或者8 （2：已解约  8：解约失败）如果不是或者没有  就按照上方接口的签约flag进行展示
    反之按照解约flag进行展示
   */
  param_findStatusInfo: {
    url: '/intraday-margin-query/bankCacheQuery/findStatusInfo',
    param: {}
  },
  // 提前交收持仓汇总
  param_addDelivery1: {
    'url': '/sec-delivery/manage/user/addDelivery',
    'param': {
      'holdDetailId': null, // 汇总写死传null
      // 'deliveryPrice': '', // 交收价格
      'deliveryQuantity': '', // 交收数量
      'holdId': '', // 持仓id
      'storageId': ''
    }
  },
  // 持仓明细卖出
  param_detailClose: {
    'url': '/intraday-trade/trade/detailClose',
    'param': {
    }
  },
  // 查询top信息
  param_searchOrder: {
    url: '/intraday-trade-query/query/searchOrder',
    param: {
      "page": 0,
      "size": 10,
      "commodityId": '', // 商品id
      "bsFlag": '', // 买卖方向
      "singlePrice": '', // 价格
      "orderId": null, // 单号
      "firmName": null, // 用户名
      "quantity": null // 数量
    }
  },
  // ---------------------现货商城，订货商城，预购结束接口start-----------------
  // 登录调用用于查询frimIdTopId
  param_getFirm: {
    'url': '/gst-user/admin/getFirm',
    'param': {}
  },
  // 现货商城商品 /shop-desk
  param_findCommodity: {
    'url': '/shop-desk/commodity/findCommodity',
    'param': {}
  },
  // 现货商城商品分类/shop-desk
  param_findClassification: {
    'url': '/shop-desk/classification/findClassification',
    'param': {}
  },
  // 现货商城商品产区-店铺查询
  param_findGstShopByClassId: {
    'url': '/shop-desk/teaShopStore/findGstShopByClassId',
    'param': {}
  },
  // 现货商城商品产区-店铺查询
  param_findGstShop: {
    'url': '/shop-desk/teaShopStore/findGstShop',
    'param': {}
  },
  // 现货商城商品产区-店铺查询  新接口
  param_findOperatingStore: {
    'url': '/shop-desk/teaShopStore/findOperatingStore',
    'param': {}
  },
  // /shop-trade 订货商城下单
  param_makeOrderIntegral: {
    'url': '/shop-trade/shopTrade/makeOrderIntegral',
    'param': {}
  },
  // 订货中心下单
  param_makeOrder: {
    'url': '/shop-trade/shopTrade/makeOrder',
    'param': {}
  },
  // 配票查询
  param_queryFirmTransposi: {
    'url': '/intraday-trade-query/query/queryFirmTransposi',
    'param': {}
  },
  // 配票操作
  param_confirmTransfer: {
    'url': '/intraday-delivery/position/confirmTransfer',
    'param': {}
  },
  // 我的预购
  param_queryPartake: {
    'url': '/shop-desk/shopOrder/queryPartake',
    'param': {}
  },
  // 我的预购下单
  param_doPurchase: {
    'url': '/shop-trade/purchase/doPurchase',
    'param': {}
  },
  // 查询预购活动
  param_findPurchase: {
    url: '/shop-desk/purchase/findPurchase',
    param: {}
  },
  // 商城可用资金查询
  param_findMyAssetMarket: {
    'url': '/base-margin-front-queryservice/margin/findMyAssetMarket',
    'param': {}
  },
  param_findMyRewardMarket: {
    'url': '/base-margin-front-queryservice/rewardQuery/findMyRewardMarket',
    'param': {}
  },
  // 获取店铺数字权益
  param_findShopCoin: {
    'url': '/shop-desk/commodity/findShopCoin',
    'param': {
    }
  },
  // 孵化
  param_findHatch: {
    'url': '/intraday-trade-query/commodity/findHatch',
    'param': {

    }
  },
  // 兑换茶资产
  param_integralExchange: {
    'url': '/intraday-trade/trade/integralExchange',
    'param': {
    }
  },
  // 查看订单详情 /shop-desk
  param_findShopOrderDetailInfo: {
    'url': '/shop-desk/shopOrder/findShopOrderDetailInfo',
    'param': {}
  },
  // 查看订单列表 /shop-desk
  param_queryShopOrderInfo: {
    'url': '/shop-desk/shopOrder/queryShopOrderInfo',
    'param': {}
  },
  // 查看物流详情
  param_getLogistic: {
    'url': '/shop-desk/aliDelivery/getLogistic',
    'param': {}
  },
  // 查看售后订单详情 /shop-desk
  param_queryGoodBackDetail: {
    'url': '/shop-desk/goodBack/queryGoodBackDetail',
    'param': {}
  },
  // 查看售后订单列表 /shop-desk
  param_queryGoodBackInfo: {
    'url': '/shop-desk/goodBack/queryGoodBackInfo',
    'param': {}
  },
  // 查看物流 /shop-desk/
  param_queryGstShopLogistics: {
    'url': '/shop-desk/shopOrder/queryGstShopLogistics',
    'param': {}
  },
  // 商城取消订单
  param_cancelmallOrder: {
    'url': '/shop-trade/shopTrade/cancelOrder',
    'param': {}
  },
  // 商城确认收货 传参orderDetailId
  param_confirmOrder: {
    'url': '/shop-trade/refund/confirmOrder',
    'param': {}
  },
  // 商城取消退货申请 传参orderDetailId id申请id
  param_cancelRefundOrder: {
    'url': '/shop-trade/refund/cancelRefundOrder',
    'param': {}
  },
  // 商城退货申请 传参orderDetailId id申请id /shop-trade
  param_refundOrder: {
    'url': '/shop-trade/refund/refundOrder',
    'param': {}
  },
  // 申请认购订单退回金额（只有mallFlag = T） orderDetailId  订单明细id
  param_applyReturnFunds: {
    'url': '/shop-trade/shopTrade/applyReturnFunds',
    'param': {}
  },
  // 申请认购订单发货 （只有mallFlag = T）orderDetailId  订单明细id
  param_applySend: {
    'url': '/shop-trade/shopTrade/applySend',
    'param': {}
  },
  // 商城删除订单
  param_deleteOrder: {
    'url': '/shop-desk/shopOrderModify/deleteOrder',
    'param': {}
  },
  // --------------------现货商城，订货商城，预购活动接口end-----------------
  param_querySymbol: {
    url: '/shop-desk/symbol/querySymbol',
    data: {
    }
  },
  // 查询企业信息
  param_queryOrgExtra: {
    url: '/intraday-trade-query/query/queryOrgExtra',
    data: {
    }
  },
  // 【缓存】资金流水查询【当前+历史】
  param_queryFirmAccountFundsFlowHCache: {
    url: '/base-margin-front-queryservice/margin/queryFirmAccountFundsFlowHCache',
    param: {
    }
  },
  // 提现页面查积分
  param_queryFeeType: {
    url: '/intraday-trade-query/query/queryFeeType',
    param: {
    }
  },
  // 新增个人开户审核
  param_saveBaseUserAudit_user: {
    url: '/base-desk-manage/baseUserAudit/v1/addOrUpdateBaseUserAuditForNaturalPerson',
    param: {
      'cartFrontImg': '', // 证件正面照片
      'cartNegativeImg': '', // 证件反面照片
      'certNo': '', //	个人证件号码
      // 'personCertType': 1, // 个人证件类型（1:身份证）
      'legalPersonName': '', // 个人姓名（个人、法人）
      'urgencyContact': '', // 紧急联系人
      'urgencyContactAddress': '', // 紧急联系人地址
      'urgencyContactPhone': '' // 紧急联系人手机号
    }
  },
  // 新增企业开户审核
  param_saveBaseUserAudit_company: {
    url: '/base-desk-manage/baseUserAudit/v1/addOrUpdateBaseUserAuditForLegalPerson',
    param: {
      'orgCertCode': '', // 组织证件代码
      'orgCertImg': '', // 组织证件照片
      // 'orgCertType': 1, // 组织证件类型（1:社会统一代码）
      'orgName': '', // 组织名称
      'cartFrontImg': '', // 证件正面照片
      'cartNegativeImg': '', // 证件反面照片
      'certNo': '', //	个人证件号码
      // 'personCertType': 1, // 个人证件类型（1:身份证）
      'legalPersonName': '', // 个人姓名（个人、法人）
      'urgencyContact': '', // 紧急联系人
      'urgencyContactAddress': '', // 紧急联系人地址
      'urgencyContactPhone': '' // 紧急联系人手机号
    }
  },
  // pc扫码跳移动端秘钥 ---- 更换手机号码 --- 视频没有超过五次
  param_getSessionKey: {
    url: '/base-desk-query/userSession/getSessionKey?type=1',
    param: {

    }
  },
  // 视频超过五次进入人工审核
  param_getSessionKey1: {
    url: '/base-desk-query/userSession/getSessionKey?type=2',
    param: {

    }
  },
  // 修改登录
  param_getSessionKey2: {
    url: '/base-desk-query/userSession/getSessionKey?type=3',
    param: {

    }
  },
  // 修改资金
  param_getSessionKey3: {
    url: '/base-desk-query/userSession/getSessionKey?type=4',
    param: {

    }
  },
  // 个人签约
  param_getSessionKey4: {
    url: '/base-desk-query/userSession/getSessionKey?type=5',
    param: {

    }
  },
  // 企业签约
  param_getSessionKey5: {
    url: '/base-desk-query/userSession/getSessionKey?type=6',
    param: {

    }
  },
  // 开户
  param_getSessionKeyOpen: {
    url: '',
    param: {

    }
  },
  // 查询审核信息
  param_findBaseUserAuditByUserId: {
    url: '/base-desk-query/baseUserAudit/v1/getBaseUserAudit',
    param: {}
  },
  //查询签名
  param_queryUserInfo: {
    url: '/base-desk-manage/user/queryUserInfo',
    param: {}
  },
  // 修改资金密码
  param_updateMoneyPwd: {
    url: '/shop-desk/securitySetting/updateMoneyPwd',
    param: {
    }
  },
  // 重置资金密码
  param_forgetMoneyPwd: {
    url: '/shop-desk/securitySetting/forgetMoneyPwd',
    param: {
    }
  },
  // 手机号明文查询名称
  param_userQueryByPhone: {
    url: '/shop-desk/margin/userQueryByPhone',
    param: {
    }
  },
  // 茶资产划转
  param_userTransfer: {
    url: '/shop-desk/margin/userTransfer',
    param: {
    }
  },
  // 茶资产是否可划转查询
  param_queryCommodityTransferConfig: {
    url: '/intraday-trade-query/query/queryCommodityTransferConfig',
    param: {
      commodityId: null
    }
  },
  // 开户
  param_getSessionKeyOpen: {
    url: '',
    param: {

    }
  },
  // 判断是企业开户/个人开户 开户类型： 1-个人开户 2-企业开户 0-未开户
  param_getOrgOrPerson: {
    url: '/base-desk-manage/userAuth/getOrgOrPerson',
    param: {}
  },
  // 查询当前状态
  param_queryAuthnStatus: {
    url: '/base-desk-manage/userAuthDict2/queryAuthnStatus',
    param: {}
  },
  // 企业 查询当前状态
  param_orgAuth_queryAuthnStatus: {
    url: '/base-desk-manage/orgAuth/queryAuthnStatus',
    param: {}
  },
  // 修改登录
  param_getSessionKey2: {
    url: '/base-desk-query/userSession/getSessionKey?type=3',
    param: {

    }
  },
    //  --------------------- 通用银行开始-------------
  // 入金展示信息
  param_showInFundInfo: {
    url: bankServe + '/fund/showInFundInfo',
    param: {}
  },
  // 本行入金
  param_fundInByMarket: {
    url: bankServe + '/fund/fundInByMarket',
    param: {}
  },
  // 出金 币种id写死人民币: 1
  param_fundOutByMarket: {
    url: bankServe + '/fund/fundOutByMarket',
    param: {}
  },
  //  --------------------- 通用银行结束-------------
    /*青岛清算所*/

  // 获取银行列表 ∆∆∆
  param_queryBank_hb: {
    url: '/qd-common-marginservice/margin/queryBank',
    param: {}
  },

  // 获取网银端入金信息
  param_queryBankName: {
    url: '/qd-common-marginservice/margin/queryBankName',
    param: {}
  },
  // 签约
  param_userSign_Q: {
    url: '/qd-common-marginservice/margin/userSign',
    param: {
      firmId: firmId,
      bankId: '',
      marketId: '10',
      cellphone: '',
      bankAccount: '',
      openBankName: '', //上海银行用
      bankCode: '', //双乾用
      fundPwd: '',
      authorizationCode: null
    }
  },
  // 解约
  param_userUnSign_Q: {
    url: '/qd-common-marginservice/margin/userUnSign',
    param: {
      firmId: firmId,
      bankId: ''
    }
  },
  // 查询是否签约
  param_findFirmIdsByUserId: {
    'url': '/intraday-trade-query/frontTradeController/findFirmIdsByUserId',
    'param': {}
  },
  // 查询市场金额
  param_mineAssetList: {
    // 'url': '/intraday-trade-query/frontTradeController/mineAssetList',
    'url': '/intraday-trade-query-mongo/mongoQuery/mineAssetList',
    'param': {}
  },

  // 拼团-开始
  // 查询所有分类
  param_pt_findClassification: {
    url: '/gb-shop-desk/classification/findClassification',
    param: {}
  },
  // 查询轮播图
  param_pt_getContentTitleList: {
    url: '/content/content/content',
    param: {
      columnId: null,
    }
  },
  // 查询秒杀
  param_pt_queryActivity: {
    url: '/gb-shop-desk/activity/queryActivity',
    param: {}
  },
  // 秒杀下单
  param_makeOrderSeckill: {
    'url': '/gb-shop-trade/shopTrade/seckillMakeOrder',
    'param': {}
  },
  // 秒杀订单支付
  param_payOrderSeckill: {
    'url': '/gb-shop-trade/shopTrade/seckillPayOrder',
    'param': {}
  },
  // 查询秒杀列表和图片
  param_pt_queryActivityList: {
    url: '/gb-shop-desk/activity/queryActivityNew',
    param: {}
  },
  // 生成订单编码
  param_createOrderCode: {
    url: '/gb-shop-trade/shopTrade/createShopOrderToken',
    param: {}
  },
  // 查询秒杀详情
  param_queryActivityCommodityDetail: {
    url: '/gb-shop-desk/activity/queryActivityCommodityDetail',
    param: {}
  },
  // 查询推荐商品(可以通过商品名称模糊查询)
  param_pt_queryCommodity: {
    url: '/gb-shop-desk/commodity/queryCommodity',
    param: {}
  },
  // 查询所有店铺
  param_pt_queryStore: {
    url: '/gb-shop-desk/store/queryStore',
    param: {}
  },
  // 计算运费
  param_calculateFreight: {
    url: '/gb-shop-trade/shopTrade/computeOrderShippingFee',
    param: {}
  },
  // 通过商品名称查询属性
  param_pt_queryAttributeLikeCommodityName: {
    url: '/gb-shop-desk/commodityInfo/queryAttributeLikeCommodityName',
    param: {}
  },
  // 通过商品名称查询品牌
  param_pt_queryBrandLikeCommodityName: {
    url: '/gb-shop-desk/commodityInfo/queryBrandLikeCommodityName',
    param: {}
  },
  // 通过筛选和商品名称查询商品
  param_pt_queryAttributeCommodityIds: {
    url: '/gb-shop-desk/commodityInfo/queryAttributeCommodityIds',
    param: {}
  },
  // 查询限购数量
  param_pt_queryLimitNum: {
    url: '/gb-shop-desk/commodity/queryLimitNum',
    param: {}
  },
  // 查询拼团活动的商品
  param_queryGrouponCommodity: {
    url: '/gb-shop-desk/activity/queryActivityCommodityNew',
    param: {}
  },
  // 首页活动商品展示
  param_queryIndexActivityCommodity: {
    url: '/gb-shop-desk/activity/queryHomeActivityCommodity',
    param: {}
  },
  // 查询运费
  param_pt_computeOrderShippingFee: {
    url: '/gb-shop-trade/shopTrade/computeOrderShippingFee',
    param: {}
  },
  // 创建订单
  param_pt_makeOrder: {
    url: '/gb-shop-trade/shopTrade/makeOrder',
    param: {}
  },
  // 生成订单编码
  param_pt_createShopOrderToken: {
    url: '/gb-shop-trade/shopTrade/createShopOrderToken',
    param: {}
  },
  // 普通商品支付接口
  param_pt_payOrder: {
    url: '/gb-shop-trade/shopTrade/payOrder',
    param: {}
  },
  // 首页活动商品展示
  param_queryIndexActivityCommodity: {
    url: '/gb-shop-desk/activity/queryHomeActivityCommodity',
    param: {}
  },
  // 拼团-结束
  // 获取服务器时间
  param_getServerTime: {
    url: '/gb-shop-desk/time/getServerTime',
    param: {}
  }
}